import React from 'react';
import { CarFrontIcon, NotificationIcon, CrossPlatformIcon, SecureIcon } from '../../utils/icons';
import '../../styles/components/HomeSection/Features.css';

const Features: React.FC = () => {
  const features = [
    {
      icon: <CarFrontIcon size={48} className="icon-svg" />,
      title: 'Simple Car Management',
      description: 'Register, manage and follow your vehicles blocking situation status with ease.'
    },
    {
      icon: <NotificationIcon size={48} className="icon-svg" />,
      title: 'Smart Notifications',
      description: 'Get instant notifications when your cars been blocked, and send instant notifications when you need to leave.'
    },
    {
      icon: <CrossPlatformIcon size={48} className="icon-svg" />,
      title: 'Cross-Platform',
      description: 'Works seamlessly on both iOS and Android devices.'
    },
    {
      icon: <SecureIcon size={48} className="icon-svg" />,
      title: 'Securized Sign-In',
      description: 'Secure authentication with your Google account.'
    }
  ];

  return (
    <section id="features" className="features-section">
        <div className="features-container">
        <h2 className="features-title">Why Choose RushHour?</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
